module.exports = __webpack_public_path__ + "static/media/mail-white.9dfb4397.webp";